<div>
  <div id="map-container">
    <div
      #primaryMap
      [style.height.px]="currentHeight"
      [style.width.px]="currentWidth"
    ></div>

    <div class="map-control"></div>
  </div>
</div>
